// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__1zD3j","icon":"SortAdornment_icon__2s2T1","up":"SortAdornment_up__MJG7I","down":"SortAdornment_down__1QJi0","active":"SortAdornment_active__3L3uC"};